module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-point-02-96260ae7dbbf3c10dc881880ac7be2c3.png";